import { isPrerenderedPath, parseLangPrefix } from '@/modules/seo/prerenderedPaths'
import { getEffectiveUiLanguage } from './uiLanguageVisibility'
import type { SupportedLanguage } from './supportedLanguages'

export function resolveInitialLanguage(): SupportedLanguage {
  if (typeof window === 'undefined') return 'en'

  const prefix = parseLangPrefix(window.location.pathname)
  if (prefix && isPrerenderedPath(window.location.pathname)) {
    return prefix.lang
  }

  return getEffectiveUiLanguage()
}
